export const selectPlaybackCurrentTime = (state) => state.app.playback.currentTime;
export const selectPlaybackFileFormat = (state) => state.app.playback.format;
export const selectPlaybackAudioPlaying = (state) => state.app.playback.playing;
